import { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled, { css } from 'styled-components/macro';

interface Props {
    className?: string;
    icon: {
        iconPrefix: IconPrefix;
        iconName: IconName;
    };
    bgColor: string;
    iconColor: string;
}

export const InfoCircle = (props: Props) => {
    if (!props.icon.iconName) {
        return null;
    }

    return (
        <S_InfoCircle className={props.className} $bgColor={props.bgColor}>
            <S_Icon
                icon={[props.icon.iconPrefix, props.icon.iconName]}
                $iconColor={props.iconColor}
            />
        </S_InfoCircle>
    );
};

const S_InfoCircle = styled.div<{ $bgColor: string }>`
    width: 100%;
    height: 100%;
    display: flex;
    border-radius: 100%;
    align-items: center;
    justify-content: center;
    ${(props) => {
        return css`
            background-color: ${props.$bgColor};
        `;
    }}
`;

const S_Icon = styled(FontAwesomeIcon)<{ $iconColor: string }>`
    font-size: 18px;
    display: flex;
    width: 18px;
    height: 18px;
    justify-content: center;
    align-items: center;
    ${(props) => {
        return css`
            color: ${props.$iconColor};
        `;
    }}
`;
